import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { combineLatestWith, map, merge, Observable, of, switchMap } from 'rxjs';

import { I18nService } from '@personal-area/global/i18n';
import { SocialLink } from '@personal-area/global/social-authorization/models';
import { SocialService, FooterSocialNetworkLinksComponent } from '@personal-area/global/social-networks';
import { AuthService } from '@personal-area/global/authorization/services';
import { UserFacade } from '@personal-area/global/users/services';
import { FooterStoreLinksComponent } from '@personal-area/global/platform-links';

import { FooterLanguageSelectComponent } from '../footer-language-select/footer-language-select.component';

@Component({
  selector: 'global-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AsyncPipe,
    TranslateModule,
    FooterStoreLinksComponent,
    FooterSocialNetworkLinksComponent,
    FooterLanguageSelectComponent,
  ],
})
export class FooterComponent {
  public socialNetworkLinks$: Observable<SocialLink[]>;
  public userLocationA3$: Observable<string>;

  constructor(
    userFacade: UserFacade,
    translateService: TranslateService,
    i18nService: I18nService,
    socialService: SocialService,
    authService: AuthService,
  ) {
    this.userLocationA3$ = userFacade.userCountry$.pipe(
      combineLatestWith(userFacade.geoLocation$),
      map(([profileCountry, geoCountry]) =>
        authService.isLoggedIn ? profileCountry : geoCountry,
      ),
    );
    this.socialNetworkLinks$ = merge(
      of({}),
      translateService.onLangChange,
    ).pipe(switchMap(() => socialService.fetch(i18nService.languageA2)));
  }
}
